var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEqualsInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1009_59203)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.53125 8.75C1.53125 8.38756 1.82506 8.09375 2.1875 8.09375H11.8125C12.1749 8.09375 12.4688 8.38756 12.4688 8.75C12.4688 9.11244 12.1749 9.40625 11.8125 9.40625H2.1875C1.82506 9.40625 1.53125 9.11244 1.53125 8.75Z",
    fill: "#1890FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.53125 5.25C1.53125 4.88756 1.82506 4.59375 2.1875 4.59375H11.8125C12.1749 4.59375 12.4688 4.88756 12.4688 5.25C12.4688 5.61244 12.1749 5.90625 11.8125 5.90625H2.1875C1.82506 5.90625 1.53125 5.61244 1.53125 5.25Z",
    fill: "#1890FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1009_59203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqualsInvoice);
export default __webpack_public_path__ + "static/media/equals-invoice.ff3aa16c.svg";
export { ForwardRef as ReactComponent };